import { CollegamentiIcon, ScalinataIcon, MemoriaIcon, OrtografiaIcon, OrtografiaMenuIcon, ClozeIcon, SpettriIcon, SerpentoniIcon } from './icons';

// Game configuration - essential static properties only
export const GAME_CONFIG = {
    spettri: {
      id: 'spettri',
      pathName: 'progressioni',
      displayName: 'Progressioni',
      backgroundColor: '#ff9e3d',
      icon: SpettriIcon,
      menuIcon: 'fa fa-arrow-up-wide-short',
      order: 6,
      hidden: false,
      is_new: false,
      level: 'B2-C2',
      catalogDescription: 'Aiuta a riconoscere pattern e sequenze logiche nel lessico italiano, allenando il ragionamento sequenziale e la capacità di ordinare elementi secondo criteri semantici',
      displayMessage: {
        notStarted: "Ricostruisci le due progressioni.",
        inProgress: "Continua a ordinare le progressioni!",
        finished: "Ottimo! Hai ordinato correttamente le progressioni."
      },
      // Landing page content
      heroTagline: "Ordina le parole, scopri il tema",
      heroDescription: "Un gioco di logica e vocabolario che sfida la tua capacità di riconoscere sequenze e progressioni linguistiche.",
      benefits: [
        { icon: "fa-brain", title: "Pensiero logico", description: "Allena il ragionamento sequenziale e la capacità di identificare i temi nascosti nelle parole." },
        { icon: "fa-puzzle-piece", title: "Vocabolario attivo", description: "Scopri nuove parole mentre ricostruisci le progressioni tematiche." },
        { icon: "fa-bolt", title: "Sfida quotidiana", description: "Ogni giorno due nuove progressioni da risolvere in ambiti lessicali diversi." }
      ],
      targetAudience: "Perfetto per chi ama sistematizzare il lessico e vuole espandere il proprio vocabolario in ampiezza, lavorando con le sfumature di significato."
    },

    serpentoni: {
      id: 'serpentoni',
      pathName: 'serpentoni',
      displayName: 'Serpentoni',
      backgroundColor: '#56c38c',
      icon: SerpentoniIcon,
      menuIcon: 'fa fa-route',
      order: 4,
      hidden: false,
      is_new: false,
      level: 'B1-C2',
      catalogDescription: 'Aiuta la riattivazione, memorizzazione e/o scoperta di lessico tematico in ambiti linguistici di alta frequenza.',
      displayMessage: {
        notStarted: 'Trova tutte le parole tema e lo strisciogramma.',
        inProgress: 'Continua a tracciare i percorsi nella griglia!',
        finished: 'Ottimo! Hai completato il Serpentoni di oggi.'
      },
      heroTagline: 'Traccia percorsi, scopri lo strisciogramma',
      heroDescription: 'Un puzzle su griglia in cui ogni lettera conta: collega i percorsi giusti per trovare tutte le parole nascoste.',
      benefits: [
        { icon: 'fa-search', title: 'Osservazione attiva', description: 'Allenati a riconoscere pattern lessicali dentro una griglia complessa.' },
        { icon: 'fa-link', title: 'Precisione lessicale', description: 'Riattiva il lessico su ambiti tematici di alta rilevanza.' },
        { icon: 'fa-lightbulb', title: 'Strategia', description: 'Bilancia intuizione e logica per scoprire parole tema e strisciogramma.' }
      ],
      targetAudience: 'Ideale per chi ama le cacce al tesoro lessicali e vuole allenare lo spirito di osservazione.'
    },

    cloze: {
      id: 'cloze',
      pathName: 'storielle',
      displayName: 'Storielle',
      backgroundColor: '#5aa7f7',
      icon: ClozeIcon,
      menuIcon: 'fa fa-align-left',
      order: 1,
      hidden: false,
      is_new: false,
      level: 'A1-B1',
      catalogDescription: 'Aiuta la riattivazione del lessico di alta frequenza, presentando brevi testi che parlano di tipiche situazioni di vita quotidiana.',
      displayMessage: {
        notStarted: "Completa i testi con le parole mancanti.",
        inProgress: "Continua a riempire gli spazi!",
        finished: "Ottimo! Hai completato il cloze di oggi."
      },
      // Landing page content
      heroTagline: "Leggi, comprendi, completa",
      heroDescription: "Immergiti in brevi racconti e completa i testi con le parole giuste. Un modo coinvolgente per migliorare la comprensione scritta.",
      benefits: [
        { icon: "fa-book-open", title: "Comprensione testuale", description: "Migliora la tua capacità di comprendere testi in italiano." },
        { icon: "fa-spell-check", title: "Grammatica in contesto", description: "Ripassa le forme grammaticali attraverso l'uso pratico, non con regole astratte." },
        { icon: "fa-feather-alt", title: "Storie quotidiane", description: "Ogni giorno una nuova storia per tenere vivo l'interesse e la curiosità." }
      ],
      targetAudience: "Ideale per studenti principianti e intermedi che vogliono consolidare grammatica e vocabolario attraverso la lettura attiva."
    },
    
    collegamenti: {
      id: 'collegamenti',
      pathName: 'collegamenti',
      displayName: 'Collegamenti',
      backgroundColor: '#d484e3',
      icon: CollegamentiIcon,
      menuIcon: 'fa fa-link',
      order: 2,
      hidden: false,
      is_new: false,
      level: 'A2-C2',
      catalogDescription: 'Aiuta la riattivazione e/o scoperta di gruppi semantici, ossia parole che appartengono ad una stessa categoria di significato (es: ricette italiane, scuole filosofiche orientali, tipologie di vini, ecc.).',
      displayMessage: {
        notStarted: "Trova 4 gruppi di 4 parole che condividono una relazione.",
        inProgress: "Continua a cercare i gruppi nascosti!",
        finished: "Perfetto! Hai trovato tutti i gruppi."
      },
      // Landing page content
      heroTagline: "Trova le connessioni nascoste",
      heroDescription: "Riordina 16 parole in 4 categorie segrete. Un esercizio che sfida la tua conoscenza delle relazioni semantiche in italiano.",
      benefits: [
        { icon: "fa-sitemap", title: "Reti semantiche", description: "Costruisci e rinforza connessioni tra parole italiane." },
        { icon: "fa-lightbulb", title: "Pensiero laterale", description: "Scopri relazioni lessicali che arricchiscono la tua comprensione della lingua." },
        { icon: "fa-trophy", title: "Difficoltà graduata", description: "Ogni puzzle propone categorie di diversa difficoltà, dalle più ovvie alle più ricercate." }
      ],
      targetAudience: "Per chi vuole esplorare connessioni lessicali inaspettate e scoprire aspetti culturali legati all'Italia."
    },
    
    scalinata: {
      id: 'scalinata',
      pathName: 'scalinata',
      displayName: 'Scalinata',
      backgroundColor: '#4acd68',
      icon: ScalinataIcon,
      menuIcon: 'fa fa-layer-group',
      order: 7,
      hidden: false,
      is_new: false,
      level: 'B1-C2',
      catalogDescription: 'Aiuta la riattivazione e/o scoperta di gruppi lessicali, ossia parole che appartengono ad un stesso ambito tematico (es: l\'arte, la casa, il cinema, ecc.).',
      displayMessage: {
        notStarted: "Scopri le parole che nascondono il tema del giorno.",
        inProgress: "Hai ancora tentativi per trovare le parole!",
        finished: "Eccellente! Hai completato tutti i livelli."
      },
      // Landing page content
      heroTagline: "Sali gradino per gradino",
      heroDescription: "Indovina parole sempre più lunghe per rivelare il tema del giorno. Un viaggio attraverso il lessico italiano.",
      benefits: [
        { icon: "fa-layer-group", title: "Vocabolario tematico", description: "Ogni giorno un nuovo tema da esplorare, con parole che spaziano dal quotidiano all'astratto." },
        { icon: "fa-chart-line", title: "Difficoltà progressiva", description: "Inizia con parole semplici e affronta gradualmente sfide sempre più complesse." },
        { icon: "fa-key", title: "Indizi contestuali", description: "Usa le lettere già rivelate come indizi per scoprire le parole successive." }
      ],
      targetAudience: "Perfetto per chi ama le sfide a difficoltà crescente e vuole ampliare il vocabolario in modo strutturato."
    },
    
    memoria: {
      id: 'memoria',
      pathName: 'binomi',
      displayName: 'Binomi',
      backgroundColor: '#eb8787',
      icon: MemoriaIcon,
      menuIcon: 'fa fa-plane',
      order: 3,
      hidden: false,
      is_new: false,
      level: 'A2-C2',
      catalogDescription: 'Aiuta la riattivazione e/o memorizzazione di coppie di elementi, unite da relazioni socio-linguistiche.',
      displayMessage: {
        notStarted: "Abbina le coppie nascoste tra gli elementi linguistici.",
        inProgress: "Continua a scoprire le coppie!",
        finished: "Fantastico! Hai scoperto tutte le coppie."
      },
      // Landing page content
      heroTagline: "Abbina, memorizza, impara",
      heroDescription: "Trova le coppie di parole: sinonimi, contrari, collocazioni e molto altro. Un gioco di memoria che rafforza il tuo italiano.",
      benefits: [
        { icon: "fa-exchange-alt", title: "Relazioni lessicali", description: "Impara sinonimi, contrari e collocazioni comuni della lingua italiana." },
        { icon: "fa-memory", title: "Memoria attiva", description: "Allena la memoria di lavoro mentre costruisci associazioni tra parole." },
        { icon: "fa-sync", title: "Richiamo rapido", description: "Aumenta la velocità con cui recuperi lessico durante le conversazioni." }
      ],
      targetAudience: "Ideale per chi vuole arricchire il proprio repertorio lessicale e riattivare il lessico dormiente."
    },
    
    ortografia: {
      id: 'ortografia',
      pathName: 'ortografia',
      displayName: 'Ortografia',
      backgroundColor: '#ffe019',
      icon: OrtografiaIcon,
      menuIcon: OrtografiaMenuIcon,
      order: 5,
      hidden: false,
      is_new: false,
      level: 'A1-C2',
      catalogDescription: 'Aiuta la riattivazione del lessico e delle coniugazioni dei verbi, focalizzandosi sulla corretta grafia delle parole.',
      displayMessage: {
        notStarted: "Crea più parole possibile con le lettere a disposizione.",
        inProgress: "Continua a formare parole!",
        finished: "Ottimo lavoro! Hai completato il gioco."
      },
      // Landing page content
      heroTagline: "Forma parole, sfida te stesso",
      heroDescription: "Combina le lettere per creare quante più parole italiane possibile. Un classico che non tramonta mai.",
      benefits: [
        { icon: "fa-font", title: "Ortografia perfetta", description: "Rafforza la corretta scrittura delle parole italiane attraverso la pratica attiva." },
        { icon: "fa-expand-arrows-alt", title: "Vocabolario espanso", description: "Scopri parole che conosci ma non usi mai e impara termini completamente nuovi." },
        { icon: "fa-book", title: "Lessico attivo", description: "Metti alla prova la tua capacità di richiamare parole imparate in precedenza." }
      ],
      targetAudience: "Per tutti i livelli: dai principianti, che consolidano il vocabolario base ai madrelingua che vogliono riscoprire parole dimenticate."
    }
};
  
// Helper functions
export const getGameConfig = (gameId) => {
    return GAME_CONFIG[gameId] || null;
};
  
export const getAllGames = () => {
    return Object.values(GAME_CONFIG).sort((a, b) => a.order - b.order);
};

// Admin can access games that are hidden from public menus (e.g. serpentoni).
export const getAllAdminGames = () => {
    return Object.values(GAME_CONFIG)
      .filter((game) => !game.hidden || game.id === 'serpentoni')
      .sort((a, b) => a.order - b.order);
};
  
export const getGameDisplayName = (gameId) => {
    const config = getGameConfig(gameId);
    return config ? config.displayName : gameId;
};
  
export const getGameMessage = (gameId, status) => {
    const config = getGameConfig(gameId);
    if (!config) return "Pronto per la sfida di oggi?";
    
    const statusKey = status === 'not_started' ? 'notStarted' : 
                     status === 'in_progress' ? 'inProgress' : 'finished';
    
    return config.displayMessage[statusKey] || "Pronto per la sfida di oggi?";
};
  
export const getGameOrder = () => {
    return getAllGames().map(game => game.id);
};
